
import React, { useEffect } from 'react';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram
} from 'react-icons/fa';
import '../../styles/appStyles.css';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerStyle = {
    minHeight: '100vh',
    background: 'var(--light-color)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 1rem'
  };

  const cardStyle = {
    background: 'linear-gradient(135deg, #ffffff, #f8f9fa)',
    borderRadius: '24px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05)',
    padding: '3.5rem',
    maxWidth: '650px',
    width: '100%',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
    border: '1px solid rgba(255, 255, 255, 0.8)',
    transform: 'perspective(1000px)',
    transition: 'all 0.6s cubic-bezier(0.23, 1, 0.32, 1)',
    animation: 'fadeIn 0.8s ease-out'
  };

  const titleStyle = {
    fontSize: '2.8rem',
    marginBottom: '2rem',
    color: 'transparent',
    backgroundImage: 'linear-gradient(45deg, var(--primary-color), var(--secondary-color))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    fontWeight: 'bold',
    letterSpacing: '1px',
    position: 'relative',
    display: 'inline-block'
  };

  const itemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '1.5rem 0',
    color: 'var(--dark-color)',
    fontSize: '1.25rem',
    padding: '1rem 1.5rem',
    borderRadius: '15px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease',
    animation: 'fadeIn 0.5s ease-out',
    animationFillMode: 'both'
  };

  const iconStyle = {
    marginRight: '1.5rem',
    color: 'var(--primary-color)',
    fontSize: '1.8rem'
  };

  const linkStyle = {
    color: 'var(--dark-color)',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    position: 'relative',
    fontWeight: '500'
  };

  const socialContainer = {
    marginTop: '3rem',
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem'
  };

  const socialIconStyle = {
    background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
    color: '#fff',
    borderRadius: '50%',
    width: '55px',
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    boxShadow: '0 10px 20px rgba(255, 71, 87, 0.2)'
  };

  const handleIconHover = (e) => {
    e.currentTarget.style.transform = 'scale(1.15) translateY(-5px)';
    e.currentTarget.style.boxShadow = '0 15px 30px rgba(255, 71, 87, 0.3)';
  };

  const handleIconLeave = (e) => {
    e.currentTarget.style.transform = 'scale(1)';
    e.currentTarget.style.boxShadow = '0 10px 20px rgba(255, 71, 87, 0.2)';
  };

  return (
    <div style={containerStyle}>
      <div 
        style={cardStyle}
        onMouseMove={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          const xPercent = x / rect.width - 0.5;
          const yPercent = y / rect.height - 0.5;

          e.currentTarget.style.transform = `perspective(1000px) rotateX(${yPercent * -5}deg) rotateY(${xPercent * 5}deg)`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'perspective(1000px)';
        }}
      >
        <h1 style={titleStyle}>Skontaktuj się z nami</h1>
        <div style={{...itemStyle, animationDelay: '0.1s'}}>
          <FaPhoneAlt style={iconStyle} />
          <a 
            href="tel:+48799139196" 
            style={linkStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--primary-color)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--dark-color)';
            }}
          >
            +48 799 139 196
          </a>
        </div>
        <div style={{...itemStyle, animationDelay: '0.2s'}}>
          <FaEnvelope style={iconStyle} />
          <a 
            href="mailto:menu.mate.service@gmail.com" 
            style={linkStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--primary-color)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--dark-color)';
            }}
          >
            menu.mate.service@gmail.com
          </a>
        </div>

        {/*<div style={socialContainer}>
          <a
            href="https://facebook.com/menumate"
            target="_blank"
            rel="noopener noreferrer"
            style={socialIconStyle}
            onMouseEnter={handleIconHover}
            onMouseLeave={handleIconLeave}
          >
            <FaFacebookF />
          </a>
          <a
            href="https://instagram.com/menumate"
            target="_blank"
            rel="noopener noreferrer"
            style={socialIconStyle}
            onMouseEnter={handleIconHover}
            onMouseLeave={handleIconLeave}
          >
            <FaInstagram />
          </a>
        </div>*/}
      </div>
    </div>
  );
};

export default ContactPage;